import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isEditing: false,
    editedPostId: null,
    modalType: null,
    contentType: '',
    project: '',
    projectTitle:'',

    mediaBlob: [],
    mediaState: {},
    visitedMedia: [],
    mediaExtension: {},
    thumbnail: {},
    videoBlobs: [],
    openedMedia: null,
    openedMediaState: {},
    initialize: false,
    initialVideo: null,
    aspectRatio: 5 / 4,

    postDescription: '',
    categories: [],
};

const UploadContentSlice = createSlice({
    name: 'uploadContentSlice',
    initialState,
    reducers: {
        handleIsEditing(state, action) {
            const data = JSON.parse(action.payload);
            state.isEditing = data.isEditing;
            state.editedPostId = data.editedPostId;
        },
        handleContentType(state, action) {
            state.contentType = action.payload;
        },
        handleModalType(state, action) {
            state.modalType = action.payload;
        },
        handleTitle(state, action) {
            state.projectTitle = action.payload;
        },
        handleMedia(state, action) {
            const data = JSON.parse(action.payload);
            state.mediaBlob = data.mediaBlob;
            state.mediaState = data.mediaState;
            state.aspectRatio = data.aspectRatio;
            state.openedMedia = data.openedMedia;
            state.openedMediaState = data.openedMediaState;
            state.mediaExtension = data.mediaExtension;
            state.visitedMedia = data.visitedMedia;
            state.videoBlobs = data.videoBlobs;
            state.thumbnail = data.thumbnail;
            state.initialVideo = data.initialVideo;
            state.initialize = data.initialize;
        },
        handleDetails(state, action) {
            const data = JSON.parse(action.payload);
            state.postDescription = data.postDescription;
            state.categories = data.categories;
            state.projectTitle = data.projectTitle;
        },
        handleInitialize(state) {
            return initialState;
        }
    }
});

export const { handleContentType, handleModalType,handleIsEditing, handleTitle, handleMedia, handleDetails, handleInitialize, handleAttachments } = UploadContentSlice.actions;

export default UploadContentSlice.reducer;